import axios, {AxiosError} from "axios";
import { API_URL, RegisterResponse, PostFilingRequest} from "../constant";
import { message} from 'antd';

export async function PostFiling(requestdata: PostFilingRequest): Promise<RegisterResponse> {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
        validateStatus: (status: number) => {
            return status >= 200 && status < 500
        }
      };

    try {
        const response = await axios.post(
          `${API_URL}api/filing/postFiling`,
          requestdata,
          config,
        );
    
        if (response.status === 200)
        {
            if (response.data.lines === 0)
            {
                message.success({
                    content: 'No transactions were posted. Check the items in pending filings!',
                    key: 'postStatus',
                    duration: 5,
                  });
            }
            else{
                message.success({ content: 'Posting completed successfully!. You will receive an email confirmation shortly.', key: 'postStatus', duration: 5 });
            }
            return { success: true, msg: "Post Filing Success"};
        }
        else if (response.status === 400)
        {
            return { success: false, msg: response.data.detail || "Validation Error" };
        }
        else if (response.status === 422)
        {
            message.error({ content: 'Posting Error: Validation Error.', key: 'fetchStatus', duration: 5 });
            return { success: false, msg: "Validation Error" };
        }
        else{
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}